import { LOCATION_CONSTRAINTS } from './constraints.js';
/**
 * Mirrors createLocationInputSchema's required-on-create rule for locationGroupId
 * (packages/shared/src/validation/location/create-input.ts) so the create form catches a blank
 * selection client-side instead of round-tripping to the server. Edit forms don't collect
 * locationGroupId (it can't change after create), so this check only runs for create.
 */
export function checkLocationGroupRequired(values) {
    if (!values.locationGroupId?.trim()) {
        return [
            {
                path: 'locationGroupId',
                message: `${LOCATION_CONSTRAINTS.locationGroupId.label} is required.`,
            },
        ];
    }
    return [];
}
//# sourceMappingURL=rules.js.map